module.exports = __webpack_public_path__ + "img/secondpic2.37de4c9e.png";